module.exports = __webpack_public_path__ + "img/flowers-7910753_1280_thumb.456ca142.png";